import "./SkillsStyles.css";
import React from 'react'

export const Skills = () => {
  return (
    <div >
        <div>
            <img width={"100%"}
             src="https://user-images.githubusercontent.com/82999542/132934744-131c1891-4a4f-4e88-a64a-36720ad7470b.png" alt=""/>
    
        </div>
        <div className="tools">
            <h1>Tools</h1><br/>
            <div><img src="https://skillicons.dev/icons?i=github,heroku,netlify,vscode" alt=""/></div>
            
        </div>
    </div>
  )
}
